import type { FingerNumbersDisplay } from 'Seeds/ExerciseContent/scaleFingering';
import { SETTINGS_REGISTRY } from 'Settings/settingsRegistry';
import type { PerUserDevicePersistence } from 'Settings/settingTypes';
import { usePerUserDeviceSettingSync } from 'Settings/usePerUserDeviceSettingSync';
import { scaleFingerNumbersHydrated } from './scaleFingerNumbersSlice';
import { scaleFingerNumbersStore } from './scaleFingerNumbersStorage';

/** How the scale finger-number setting is kept: per user, on the device. */
export const scaleFingerNumbersPersistence: PerUserDevicePersistence<FingerNumbersDisplay> = {
  store: scaleFingerNumbersStore,
  hydrate: scaleFingerNumbersHydrated,
};

/** Keeps the scale finger-number setting in step with the signed-in user. Mount once. */
export function useScaleFingerNumbersSync(userId: string | undefined): void {
  usePerUserDeviceSettingSync(
    SETTINGS_REGISTRY.scaleFingerNumbers,
    scaleFingerNumbersPersistence,
    userId,
  );
}
